import React from 'react';
import { Button, Skeleton, SkeletonItem, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  resultWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: '36px',
    gap: tokens.spacingHorizontalXXL,
  },
  cardWrapper: {
    backgroundColor: '#fff',
    width: '358px',
    height: '164px',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: tokens.spacingHorizontalM,
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: tokens.spacingHorizontalM,
  },
  headerTitle: {
    width: '183px',
  },
  headerSubTitle: {
    width: '100px',
    marginTop: tokens.spacingVerticalM,
  },
  footerRow: {
    display: 'flex',
    flexDirection: 'column',
    padding: tokens.spacingHorizontalM,
    marginTop: tokens.spacingVerticalXXL,
  },
  footerDescription: {
    width: '100%',
  },
  footerButton: {
    marginTop: tokens.spacingVerticalM,
    width: 'fit-content',
  },
});

const AdvertiserResultShimmer = () => {
  const classes = useStyles();
  return (
    <div className={classes.cardWrapper}>
      <Skeleton animation="wave">
        <div className={classes.headerRow}>
          <SkeletonItem shape="circle" size={36} />
          <div className={classes.headerText}>
            <SkeletonItem className={classes.headerTitle} shape="square" size={12} />
            <SkeletonItem className={classes.headerSubTitle} shape="square" size={12} />
          </div>
        </div>
        <div className={classes.footerRow}>
          <SkeletonItem className={classes.footerDescription} shape="square" size={12} />
          <Button className={classes.footerButton} appearance="primary" disabled disabledFocusable>
            See all ads
          </Button>
        </div>
      </Skeleton>
    </div>
  );
};

const AdvertiserResultLoadingEffectComponent = () => {
  const classes = useStyles();
  const adResultShimmers = [...Array(12)].map((_, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <AdvertiserResultShimmer key={index} />
  ));

  return (
    <div className={classes.resultWrapper}>
      { adResultShimmers }
    </div>
  );
};

export const AdvertiserResultLoadingEffect = AdvertiserResultLoadingEffectComponent;
